import { useEffect, useState } from "react";
import { ExternalLink, Loader2 } from "lucide-react";
import { tarifasApi } from "./api";
import { PriceRows, ReasonLists } from "./ProposalCard";

export const PickedPreview = ({ fileId, providerKey, kimkimId, testId }) => {
  const [pv, setPv] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    setPv(null);
    setErr("");
    tarifasApi.preview(fileId, providerKey, kimkimId)
      .then((d) => alive && setPv(d))
      .catch((e) => alive && setErr(e?.response?.data?.detail || "No se pudo calcular la vista previa"));
    return () => { alive = false; };
  }, [fileId, providerKey, kimkimId]);

  if (err) return <p className="text-xs text-red-700 mt-2" data-testid={`${testId}-error`}>{err}</p>;
  if (!pv) return <p className="text-xs text-muted-foreground mt-2 flex items-center gap-1" data-testid={`${testId}-loading`}><Loader2 className="h-3 w-3 animate-spin" /> Calculando precios para la actividad elegida…</p>;
  return (
    <div className="mt-2 rounded-md bg-sky-50/60 border border-sky-100 p-2" data-testid={testId}>
      <p className="text-xs text-sky-900 flex items-center gap-1 flex-wrap">
        Vista previa con la actividad elegida: <strong>{pv.kimkim_title}</strong>
        <a href={pv.kimkim_url} target="_blank" rel="noreferrer" className="text-primary underline flex items-center gap-0.5">abrir en KimKim <ExternalLink className="h-3 w-3" /></a>
        {(pv.kimkim_location || pv.kimkim_operator || pv.kimkim_price_notes) && <span className="text-muted-foreground">· {[pv.kimkim_location, pv.kimkim_operator ? `operador ${pv.kimkim_operator}` : null, pv.kimkim_price_notes ? `notas «${pv.kimkim_price_notes}»` : null].filter(Boolean).join(" · ")}</span>}
      </p>
      {pv.rows?.length > 0 ? <PriceRows rows={pv.rows} testPrefix={testId} /> : <p className="text-xs text-amber-800 mt-1">{pv.reasons?.[0] || "Sin tramos comparables"}</p>}
      {pv.rows?.length > 0 && <ReasonLists notes={pv.notes} reasons={pv.reasons} testId={testId} />}
    </div>
  );
};
